import React from "react";

/* ============================================================================
   OtpInput — the one-time code, as a single field.

   This replaced six separate boxes. The six-box version advanced focus with
   element.nextSibling on every keystroke, which meant Backspace landed in an
   already-empty box and appeared to do nothing: to correct a digit a customer
   had to reach back and tap the box itself. One field has none of that — the
   caret is where the text is, so Backspace, arrow keys, select-all and paste
   all behave the way they do in any other field.

   It also fixes autofill. Only the first of the six boxes could carry
   autoComplete="one-time-code", so the OS could offer the code from the SMS but
   had nowhere to put the other five digits.

   Wide letter tracking keeps the six characters legible as six, which was the
   one thing the separate boxes were genuinely good at.
   ============================================================================ */

const OtpInput = ({
  id = "otp",
  value = "",
  onChange,
  length = 6,
  invalid = false,
  describedBy,
}) => {
  /* Digits only, and never longer than the code. Filtering here rather than in
     the caller means paste is cleaned too: a customer copying "Your code is
     123456" from the SMS lands six digits in the field, not a rejection. */
  const handleChange = (event) => {
    const digits = event.target.value.replace(/\D/g, "").slice(0, length);
    onChange(digits);
  };

  return (
    <div
      className={`ui-otp ${invalid ? "ui-otp--invalid" : ""} ${
        value.length === length ? "ui-otp--complete" : ""
      }`}
    >
      <input
        id={id}
        className="ui-otp__input"
        type="text"
        /* Numeric keypad without the spinner arrows and length limits that
           type="number" would bring — a code is a string of digits, not a
           quantity. */
        inputMode="numeric"
        autoComplete="one-time-code"
        maxLength={length}
        value={value}
        onChange={handleChange}
        placeholder={"·".repeat(length)}
        aria-invalid={invalid}
        aria-describedby={describedBy}
      />
    </div>
  );
};

export default OtpInput;
